import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, DatePicker, Icon, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import moment from 'moment';
import { saveSearchParams } from '../../../actions/rankActions';

const { MonthPicker } = DatePicker;
const monthFormat = 'YYYY-MM';

class RankTable extends Component {
    state = {
        list: [],
    }

    componentDidMount() {
        this.queryEffectiveDate();
    }

    queryEffectiveDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const maxDate = `${res.year}-${res.month < 10 ? `0${res.month}` : res.month}`;
            this.setState({
                maxDate,
                monthDate: moment(maxDate),
            }, () => {
                this.loadData();
            });
        });
    }

    loadData = () => {
        const { rankUrl } = this.props;
        const { maxDate, monthDate = null } = this.state;
        this.setState({ loading: true });
        const date = monthDate ? monthDate.format(monthFormat) : maxDate;

        const options = {
            method: 'POST',
            url: rankUrl,
            data: {
                startDate: date,
                endDate: date,
                limit: 10,
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    loading: false,
                    meanValue: res.avg,
                    list: res.result.datas,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        }
        $.sendRequest(options);
    }

    getColumns = () => {
        const { rankName } = this.props;
        const columns = [
            {
                title: '排名',
                dataIndex: 'rank',
                width: 60,
            }, {
                title: rankName,
                dataIndex: 'userCompellation',
                render: (text, record) => `${record.userCompellation}[${record.employeeCode}]`,
                width: 120,
            }, {
                title: '总分',
                dataIndex: 'trueTotalPoint',
                width: 90,
            }, {
                title: '主要业绩分',
                dataIndex: 'mainAchievementPoint',
                width: 95,
            }, {
                title: '加分',
                dataIndex: 'bonusPoint',
                width: 90,
            }, {
                title: '减分',
                dataIndex: 'minusPoint',
                width: 90,
            },
        ];
        return columns;
    }

    getDataSource = () => {
        const { list } = this.state;
        const dataSource = list.map((item, index) => (
            {
                index: index + 1,
                ...item,
            }
        ));
        return dataSource;
    }

    handleDateChange = (date, dateString) => {
        this.setState({ monthDate: date }, () => {
            this.loadData();
        });
    }

    prevMonth = () => {
        const { monthDate } = this.state;
        this.setState({ monthDate: monthDate.subtract(1, 'M') }, () => {
            this.loadData();
        });
    }

    nextMonth = () => {
        const { monthDate, maxDate } = this.state;
        const newMonthDate = moment(monthDate.format(monthFormat)).add(1, 'M');
        if (newMonthDate.valueOf() > moment(maxDate).valueOf()) {
            message.warning('不能大于该月份！');
            return;
        }
        this.setState({ monthDate: newMonthDate }, () => {
            this.loadData();
        });
    }

    disabledDate = (current) => {
        const { maxDate } = this.state;
        const value = moment(maxDate).valueOf();
        return current && current.valueOf() > value;
    }

    goToRank = () => {
        const { toPath } = this.props;
        const { maxDate = '', monthDate = null } = this.state;
        const performanceState = { params: {} };
        this.props.saveParams(performanceState);
        location.href = `/#/${toPath}/${monthDate ? monthDate.format(monthFormat) : maxDate}`;
    }

    render() {
        const { rankName } = this.props;
        const { monthDate = null, meanValue = 0, loading } = this.state;
        return (
            <article className="performanceTable flexItem outer">
                <header className="modTitle">{rankName}绩效排行</header>
                <content className="boby">
                    <header className="monthSelect1">
                        <Icon type="left-circle-o" style={{ color: '#5850C9' }} onClick={this.prevMonth} />
                        <MonthPicker allowClear={false} value={monthDate} format={monthFormat} onChange={this.handleDateChange} disabledDate={this.disabledDate} />
                        <Icon type="right-circle-o" style={{ color: '#5850C9' }} onClick={this.nextMonth} />
                        <strong style={{ position: 'absolute', right: 20, lineHeight: '28px' }}>均值：{meanValue}</strong>
                    </header>
                    <div className="tableWrap">
                        <Table
                            bordered={false}
                            loading={loading}
                            pagination={false}
                            columns={this.getColumns()}
                            dataSource={this.getDataSource()}
                            rowKey={record => record.index}
                        />
                    </div>
                </content>
                <footer className="footer">
                    <a className="more" onClick={this.goToRank}>{`查看更多>>`}</a>
                </footer>
            </article>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    saveParams: (params) => dispatch(saveSearchParams(params))
})

export default connect(null, mapDispatchToProps)(RankTable);


// WEBPACK FOOTER //
// ./src/components/homePage/performanceRank/RankTable.js